import * as React from "react";
import ConfigContext from "../context/ConfigContext";
import { EngagementConfiguration } from "../types";
import { HeaderSmileyIcon } from "./Icons";

interface Props {
  config: EngagementConfiguration;
}

function HeaderLogo(props: Props) {
  if (props.config.ChatHeaderImageType === "None") {
    return null;
  }

  const logoUrl = props.config.HeaderLogoUrl;

  if (!logoUrl) {
    return <HeaderSmileyIcon />;
  }

  return (
    <img
      className="velaro-header-logo"
      src={logoUrl}
      alt=""
      role="presentation"
    />
  );
}

export default () => (
  <ConfigContext.Consumer>
    {config => <HeaderLogo config={config} />}
  </ConfigContext.Consumer>
);
